import { getApiRequest } from 'api';

import { MeetingFileData } from '.';

export const getMeetingTemplateFiles = (lesson: number): Promise<MeetingFileData[]> => {
    return getApiRequest(`/meeting/files/?lesson=${lesson}`);
};
